// Import flickity
import Flickity from 'flickity';

// Set global arrowShape
const arrowShape = 'M50.4834 75.4838C48.4494 77.5178 48.4494 80.8155 50.4834 82.8495C52.5174 84.8835 55.8151 84.8835 57.8491 82.8495L87.0158 53.6828C87.9926 52.7061 88.5413 51.3813 88.5413 50C88.5413 48.6187 87.9926 47.2939 87.0158 46.3171L57.8491 17.1505C55.8151 15.1165 52.5174 15.1165 50.4834 17.1505C48.4495 19.1845 48.4495 22.4822 50.4834 24.5162L70.759 44.7917H16.6663C13.7899 44.7917 11.458 47.1235 11.458 50C11.458 52.8765 13.7899 55.2083 16.6663 55.2083H70.759L50.4834 75.4838Z'; // prettier-ignore

// USP Slider
document.querySelectorAll('.usp-slider').forEach((e) => {
  if (e.querySelectorAll('.usp-slider__item').length <= 1) return;

  const flkty = new Flickity(e, {
    cellAlign: 'left',
    watchCSS: true,
    wrapAround: true,
    prevNextButtons: false,
    pageDots: false,
    autoPlay: 5000,
  });

  flkty.resize();
});

// News slider
const initNewsFlickity = function (parent) {
  if (!parent) {
    return;
  }
  parent.querySelectorAll('.news-slider').forEach((e) => {
    if (
      (window.innerWidth < 768 &&
        e.querySelectorAll('.news-slider__item').length > 1) ||
      (window.innerWidth > 767 &&
        window.innerWidth < 1025 &&
        e.querySelectorAll('.news-slider__item').length > 2) ||
      (window.innerWidth > 1024 &&
        e.querySelectorAll('.news-slider__item').length > 3)
    ) {
      const flkty = new Flickity(e, {
        arrowShape,
        cellAlign: 'left',
        contain: true,
        groupCells: true,
      });
      flkty.resize();
    } else if (e.classList.contains('flickity-enabled')) {
      Flickity.data(e).destroy();
    }
  });
};

// Image slider
const initImageFlickity = function (parent) {
  if (!parent) {
    return;
  }
  parent.querySelectorAll('.js-img-slider').forEach((e) => {
    if (e.querySelectorAll('.js-img-slider__item').length <= 1) return;

    const flkty = new Flickity(e, {
      wrapAround: true,
      arrowShape,
    });

    flkty.resize();
  });
};

// Testimonial slider
const initTestimonialFlickity = function (parent) {
  if (!parent) {
    return;
  }
  parent.querySelectorAll('.js-testimonial-slider').forEach((e) => {
    if (e.querySelectorAll('.js-testimonial-slider__item').length <= 2) return;

    const flkty = new Flickity(e, {
      cellAlign: 'left',
      groupCells: true,
      contain: true,
      arrowShape,
    });

    flkty.resize();
    let resizeTimer;
    window.addEventListener('resize', () => {
      document
        .querySelectorAll('.js-testimonial-slider__item')
        .forEach((item) => item.classList.add('reset-height'));

      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        document
          .querySelectorAll('.js-testimonial-slider__item')
          .forEach((item) => item.classList.remove('reset-height'));
      }, 250);
    });
  });
};

// Logo slider
const initLogosFlickity = function (parent) {
  if (!parent) {
    return;
  }
  parent.querySelectorAll('.js-logo-slider').forEach((e) => {
    if (e.querySelectorAll('.js-logo-slider__item').length <= 1) return;

    const flkty = new Flickity(e, {
      cellAlign: 'center',
      groupCells: true,
      pageDots: false,
      prevNextButtons: false,
      contain: true,
      arrowShape,
    });

    flkty.resize();
  });
};

// Team slider
const initTeamFlickity = function (parent) {
  if (!parent) {
    return;
  }
  parent.querySelectorAll('.team-slider').forEach((e) => {
    if (e.querySelectorAll('.card-team').length <= 1) return;

    const flkty = new Flickity(e, {
      watchCSS: true,
      wrapAround: true,
      arrowShape,
    });

    flkty.resize();
  });
};

document.addEventListener('DOMContentLoaded', function () {
  initNewsFlickity(document.querySelector('.block-news'));
  initImageFlickity(document.querySelector('.block-slider'));
  initTestimonialFlickity(document.querySelector('.block-testimonial'));
  initLogosFlickity(document.querySelector('.block-logos'));
  initTeamFlickity(document.querySelector('.block-team'));

  if (typeof acf !== 'undefined') {
    window.acf.addAction('render_block_preview/type=news', function ($block) {
      initNewsFlickity($block.get(0));
    });
    window.acf.addAction('render_block_preview/type=slider', function ($block) {
      initImageFlickity($block.get(0));
    });
    window.acf.addAction(
      'render_block_preview/type=testimonial',
      function ($block) {
        initTestimonialFlickity($block.get(0));
      },
    );
    window.acf.addAction('render_block_preview/type=logos', function ($block) {
      initLogosFlickity($block.get(0));
    });
    window.acf.addAction('render_block_preview/type=team', function ($block) {
      initTeamFlickity($block.get(0));
    });
  }
});
